(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gorgias-chat"] && !Shopify.designMode) return;
  try {
    /**
 * Custom element that manages Gorgias chat widget behavior.
 * Adds click-outside-to-close functionality to the Gorgias chat window.
 */
class GorgiasChatManager extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
  }

  connectedCallback() {
    // Abort controller for event listener cleanup
    this.abortController = new AbortController();

    // Wait for Gorgias widget to be ready (scripts initialize automatically)
    const waitForReady = () => {
      if (window.GorgiasChat) {
        this.setupClickHandlers();
      } else {
        window.addEventListener('gorgias-widget-loaded', () => this.setupClickHandlers(), {
          once: true,
          signal: this.abortController?.signal
        });
      }
    };

    waitForReady();
  }

  setupClickHandlers() {
    document.addEventListener('click', this.handleDocumentClick.bind(this), {
      signal: this.abortController?.signal
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  /**
   * Handles clicks on the document for both opening and closing chat.
   * - Opens chat when clicking elements with [data-gorgias-chat-open]
   * - Closes chat when clicking outside the chat container
   * 
   * @param {MouseEvent} event - The click event from document
   */
  handleDocumentClick(event) {
    // Check if clicking a trigger element to open chat
    const trigger = event.target.closest('[data-gorgias-chat-open]');
    if (trigger) {
      if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
        window.GorgiasChat.open();
      }
      return;
    }

    // Close chat when clicking outside
    const container = document.querySelector('#gorgias-chat-container');
    if (!container) return;

    if (!container.contains(event.target)) {
      if (window.GorgiasChat && typeof window.GorgiasChat.close === 'function') {
        window.GorgiasChat.close();
      }
    }
  }
}

function initGorgiasChatManager() {
  if (customElements.get('gorgias-chat-manager')) {
    return;
  }
  customElements.define('gorgias-chat-manager', GorgiasChatManager);
}

initGorgiasChatManager();
  } catch(e) { console.error(e); }
})();

})();
